// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"3044f485","55":"3605c415","75":"8d95f848","172":"7f692bef","415":"070fe612","887":"86b38dca"}[chunkId] + ".css";
};